module.exports = __webpack_public_path__ + "img/11_47.c0844706.png";